import React from 'react';
import { useIntl } from 'react-intl';
import { AssetStatus } from '../listHelpers';

interface AssetStatusPillProps {
  status: AssetStatus | null;
}

/**
 * Message ids are spelled out per branch: the intl extraction plugin only
 * accepts statically evaluate-able ids, so a lookup table will not build.
 */
const AssetStatusPill: React.FC<AssetStatusPillProps> = ({ status }) => {
  const intl = useIntl();

  // No status set yet: say so plainly rather than implying a state.
  if (!status) {
    return (
      <span className="asset-status-pill asset-status-pill--none">
        {intl.formatMessage({ id: 'assets.status.none' })}
      </span>
    );
  }

  const label =
    status === 'Operational'
      ? intl.formatMessage({ id: 'assets.status.operational' })
      : status === 'Maintenance'
      ? intl.formatMessage({ id: 'assets.status.maintenance' })
      : intl.formatMessage({ id: 'assets.status.offline' });

  return (
    <span className={`asset-status-pill asset-status-pill--${status.toLowerCase()}`}>{label}</span>
  );
};

export default AssetStatusPill;
